import { Component, HostListener, SimpleChanges } from '@angular/core';
import { AuthGuard, AuthenticationService} from '../../auth/index';
import { AppService } from '../../app.service';
import { Cookie } from 'ng2-cookies';
import { Globals } from '../../globals';
import { UserIdleService } from 'angular-user-idle';
import customerJson from "../../../assets/config/customer.json";
import translateJson from "../../../translate.json";
import versionJson from "../../../assets/version.json";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Component({
  selector: 'layout-header',
  providers: [AppService],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent {    
    currentUser: any;
    showTimeoutModal: boolean = false;
    content: string;
    title: string;
    idle: number;
    timeout: number;
    ping: number;
    counter: number;
    timeoutConfig: any = [];
    customer: any = customerJson.customer;
    i18 = translateJson.i18;
    scmVersion:string = versionJson.scmVersion;

    @HostListener('document:mousemove', ['$event'])
    onMouseMove(e) {
        if (this.showTimeoutModal && this.authService.isUserAuthenticated()) {
            this.restart();            
            this.hideTimeoutWarning();
            this.authService.getNewToken();            
        }
    }

    @HostListener('document:keypress', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (this.showTimeoutModal && this.authService.isUserAuthenticated()) {
            this.restart();            
            this.hideTimeoutWarning();            
            this.authService.getNewToken(); 
        }
    }

    constructor(
        private authGuard: AuthGuard,
        private authService: AuthenticationService,
        private appService: AppService,
        private userIdle: UserIdleService,
        private globals: Globals,
        private http: HttpClient) {
          this.idle = globals.idle;
          this.timeout = globals.timeout;
          this.ping = globals.ping;
          this.timeoutConfig = [this.idle, this.timeout, this.ping];
        }

    ngOnInit() : void {
        this.userIdle.setConfigValues(this.timeoutConfig);
        this.userIdle.startWatching();
        this.userIdle.ping$.subscribe(() => this.pingServer());
        this.userIdle.onTimerStart().subscribe(count => this.displayTimeoutWarning(count));
    }

    /**
    * Display modal when timeout countdown starts
    */
    displayTimeoutWarning(count) {
        this.counter = count;
        if (this.counter != null || this.counter != undefined) {
            if (this.authService.isUserAuthenticated()) {
                this.title = this.i18.modals.inactivityModal.inactivityMessage;
                this.showTimeoutModal = true;
                if (this.counter >= this.timeout) {
                    this.hideTimeoutWarning();
                    this.stop(); // Stop timer when logOut
                    this.logOut();
                }
            }
        }
    }

    /**
    * Ping resource server
    */
    pingServer() {
      this.authService.getNewToken(); 
    }

    /**
    * Hide modal for time out
    */
    hideTimeoutWarning() {
        this.showTimeoutModal = false;
    }

    /**
    * Stop timer for userIdle
    */
    stop() {
      this.userIdle.stopTimer();
    }

    /**
    * Stop watching userIdle
    */
    stopWatching() {
      this.userIdle.stopWatching();
    }

    /**
    * Start watching userIdle
    */
    startWatching() {
      this.userIdle.startWatching();
    }

    /**
    * Re-start watching userIdle
    */
    restart() {
      this.userIdle.resetTimer();
    }

    logOut() : void {
        this.authService.logout();
    }

   /**
   * Set the URL-route to the specified route
   * @param route Route to change to
   */
  setRoute(route) {
    let routeName = '';
    if(route != undefined && route != null && route != '') {
      routeName = route.replaceAll('/', '');
    }  
    let lastViewedComponent = JSON.parse(localStorage.getItem('lastComponent'));
    if(lastViewedComponent != undefined && lastViewedComponent != null && lastViewedComponent !== routeName) {
        localStorage.setItem('lastSearch', JSON.stringify([]));
        localStorage.setItem('filterList', JSON.stringify([]));
        localStorage.setItem('lastViewedPage', JSON.stringify(1));
        localStorage.removeItem('lastViewedAnchor');
    }
    this.appService.setRoute(route);
  }
}